// BillingTable.jsx
import React, { useEffect } from "react";

const BillingTable = ({
    items = [],
    totalAmount = 0,
    totalPaidAmount = 0,
    totalDiscountAmount = 0,
    totalRemainingAmount = 0,
    handleTotalAmount,
    handleTotalDiscount,
    handleTotalRemaining,
    onItemChange,
    onItemDelete,
    serviceErrorMsg,
    totalRefundAmount = 0,
    isDisabled
}) => {

    const Disabled = isDisabled;

    useEffect(() => {
        let calculatedTotalAmount = 0;
        let calculatedDiscount = 0;

        items.forEach(({ quantity = 1, amount = 0, price = 0, discount = 0 }) => {
            const qty = parseFloat(quantity) || 0;
            const rate = parseFloat(amount || price) || 0;
            const disc = parseFloat(discount) || 0;
            calculatedTotalAmount += qty * rate;
            calculatedDiscount += disc;
        });

        const finalTotal = calculatedTotalAmount - calculatedDiscount;
        const paid = parseFloat(totalPaidAmount) || 0;
        const refund = parseFloat(totalRefundAmount) || 0;
        const remaining = finalTotal - (paid + refund);

        handleTotalAmount(calculatedTotalAmount);
        handleTotalDiscount(calculatedDiscount, finalTotal);
        handleTotalRemaining(remaining);

    }, [items, totalPaidAmount]);

    const displayValue = (val) => val === 0 ? "" : val;

    return (
        <div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>S No.</th>
                        <th>Items</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                        <th>Discount</th>
                        <th>Sub-total</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length > 0 ? (
                        items.map((item, idx) => {
                            const quantity = parseFloat(item.quantity) || 0;
                            const amount = parseFloat(item.amount || item.price) || 0;
                            const discount = parseFloat(item.discount) || 0;
                            const subtotal = quantity * amount - discount;

                            return (
                                <tr key={item.id}>
                                    <td>{idx + 1}</td>
                                    <td>{item.item}</td>
                                    <td>
                                        <input
                                            type="number"
                                            value={displayValue(item.quantity)}
                                            onChange={(e) => onItemChange(item.id, "quantity", e.target.value)}
                                            className="form-control"
                                            disabled={Disabled}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            value={displayValue(item.amount || item.price)}
                                            onChange={(e) => onItemChange(item.id, "amount", e.target.value)}
                                            className="form-control"
                                            disabled={true}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            value={displayValue(item.discount)}
                                            onChange={(e) => onItemChange(item.id, "discount", e.target.value)}
                                            className="form-control"
                                            disabled={Disabled}
                                        />
                                    </td>
                                    <td>{subtotal.toFixed(2)}</td>
                                    <td>
                                        {/* <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => onItemDelete(item.id)}
                                        >
                                            Delete
                                        </button> */}
                                        <i
                                            className={`fa fa-trash text-danger ${Disabled ? 'disabled-trash' : ''}`}
                                            onClick={() => {
                                                if (!Disabled) {
                                                    onItemDelete(item.id, item);
                                                }
                                            }}
                                            style={{
                                                cursor: Disabled ? 'not-allowed' : 'pointer',
                                                opacity: Disabled ? 0.5 : 1,
                                            }}
                                            aria-hidden="true"
                                        />

                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center">No services added yet.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {serviceErrorMsg &&
                <span style={{ color: "red" }}>{serviceErrorMsg}</span>
            }
            <div className="mt-3 billing-info-table-reg">
                <p style={{ margin: "5px" }}><strong>Total Amount:</strong> ₹{Number(totalAmount).toFixed(2)}</p>
                <p style={{ margin: "5px" }}><strong>Total Discount:</strong> ₹{Number(totalDiscountAmount).toFixed(2)}</p>
                <p style={{ margin: "5px" }}><strong>Final Total:</strong> ₹{(Number(totalAmount) - Number(totalDiscountAmount)).toFixed(2)}</p>
                <p style={{ margin: "5px" }}><strong>Amount Paid:</strong> ₹{(Number(totalPaidAmount)).toFixed(2)}</p>
                <p style={{ margin: "5px" }}><strong>Balance:</strong> ₹{Number(totalRemainingAmount).toFixed(2)}</p>
                <p style={{ margin: "5px" }}><strong>Refund:</strong> ₹{Number(totalRefundAmount).toFixed(2)}</p>
            </div>
        </div>
    );
};

export default BillingTable;
